import styled, { css } from 'styled-components'
import Calendar from 'presentation/shared/components/Calendar'

export const InputWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 30px;
`

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  input {
    max-width: 170px;
  }

  select {
    max-width: 170px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export const ProcessContainer = styled.div`
  display: flex;
  gap: 7px;

  label {
    font-weight: ${({ theme }) => theme.font.normal};
    color: ${({ theme }) => theme.colors.gray};
  }
`

export const Label = styled.label`
  font-weight: ${({ theme }) => theme.font.normal};
  color: ${({ theme }) => theme.colors.gray};
  margin-top: 20px;
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;

  .on_time {
    background: ${({ theme }) => theme.ds.colors.success500};
  }

  .late {
    background: ${({ theme }) => theme.ds.colors.attention700};
  }

  .critic {
    background: ${({ theme }) => theme.ds.colors.danger700};
  }
`

export const Tag = styled.div`
  padding: 4px 16px;
  border-radius: 16px;
  color: ${({ theme }) => theme.ds.colors.white};
`

export const StyledCalendar = styled(Calendar)<{
  show: boolean
  right?: boolean
}>`
  position: absolute;
  top: 34px;
  width: 300px;
  display: ${({ show }) => (show ? 'block' : 'none')};
  right: ${({ right }) => right && '0px'};
`

export const InputCalendar = styled.div`
  position: relative;
  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
  z-index: 2;
`

export const PannelContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TabWrapper = styled.div`
  width: 70%;
`

export const ArrowDivContainer = styled.div`
  display: flex;
  gap: 25px;
  display: flex;
  justify-content: left;
`

export const ArrowDiv = styled.div<any>`
  width: 200px;
  height: 40px;
  position: relative;
  background: ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.white};
  color: ${({ theme, selected }) =>
    selected ? theme.colors.white : theme.colors.neutral500};

  display: flex;
  justify-content: center;
  align-items: center;

  &:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    :after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 20px solid
        ${({ theme, selected }) =>
          selected ? theme.colors.primary : theme.colors.white};
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

    :before {
      content: '';
      position: absolute;
      right: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 20px solid
        ${({ theme, selected }) =>
          selected ? theme.colors.primary : theme.colors.white};
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
  }

  :after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid ${({ theme }) => theme.colors.mainBg};
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }
  :before {
    content: '';
    position: absolute;
    right: -20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid
      ${({ theme, selected }) =>
        selected ? theme.colors.primary : theme.colors.white};
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }
`

export const BoxNotifications = styled.div`
  position: fixed;
  display: block;
  width: 100%;
  max-width: 500px;
  top: 72px;
  bottom: 0;
  right: 0;
  transform: translateX(102%);
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 8px 10px 2px rgba(0, 0, 0, 0.15);
  transition: transform ease-in-out 0.3s;
  z-index: 2;
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    max-width: unset;
  }

  &.-open {
    transform: translateX(0);
  }
`

export const BoxContent = styled.div`
  overflow-y: auto;
  height: calc(100% - 80px); //80px = BoxHeader height + margin-bottom
  padding: 0 14px 0 24px;
  @media (max-width: 500px) {
    padding: 0 6px 0 16px;
  }
`

export const BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  margin: 0 24px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.medGray};

  @media (max-width: 768px) {
    justify-content: flex-start;
  }

  @media (max-width: 500px) {
    margin: 0 16px 8px;
  }

  h4 {
    margin-left: 0;
    font-size: ${({ theme }) => theme.font.sizes.medium};
    font-weight: ${({ theme }) => theme.font.semiBold};
    color: ${({ theme }) => theme.colors.neutralBlack};
  }

  .btn {
    background-color: unset;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 2px;

    &.-back {
      display: none;

      @media (max-width: 768px) {
        display: flex;
        margin-right: 15px;
      }
    }

    &.-close {
      &:hover {
        svg {
          fill: ${({ theme }) => theme.colors.gray};
        }
      }
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`

export const CheckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CheckInfo = styled.p<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    text-transform: capitalize;
    margin-top: 6px;
    font-size: ${theme.ds.typography.size.xxsmall};
    font-weight: ${theme.ds.typography.weight.normal};
    line-height: ${theme.ds.typography.lineHeight.small};
    color: ${disabled
      ? theme.ds.colors.neutral300
      : theme.ds.colors.neutral600};
  `}
`

export const BoxAction = styled.div`
  margin-top: auto;
  margin-bottom: 0;
`
